module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chap"
  }, [_c('p', {
    staticClass: "chap-title",
    attrs: {
      "id": "sec8"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('b', [_vm._v("The Basics")])])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("ABOUT FELTED WOOL")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("I am often asked about felted wool, and this is how I explain the differences in wool fabric.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Felted wool is actually woven wool yardage that has a weft and a warp. When this yardage is felted, it is shrunk in hot water followed by high-heat drying, causing it to constrict and become dense. This fabric is easy to needle because the holes between the warp and weft remain. Once felted, woven wool yardage will not easily fray.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Wool felt is made from wool roving, which is pressed into sheets using hot water and high heat, causing it to become dense. This fabric is a bit more difficult to needle because unlike a woven fabric it has no holes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Some wool felt is actually a blend of 70% wool and 30% polyester and behaves well in a variety of applications because it has absolutely no fray.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Craft felt is made from 100% synthetic materials. Some is even made using recycled plastic bottles … a much different feel and form.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("I use felted wool for all my base fabrics and the majority of my appliqué fabrics. My process is to felt all my own base fabrics (white, off-white, and black), dye and overdye some of my own colors when I am unable to procure suitable colors, and buy from felted wool houses all the colors that are used in smaller pieces.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("I hope your journey using this book will encourage you to felt your own wool, experiment with a bit of dyeing and overdyeing, and see how beautifully these natural fibers needle and behave as you sculpt your own creations.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("FELTING WOOL")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Wool yardage can be felted by washing it with hot water and a little detergent and then drying it at high heat. The fabric will shrink nicely and eliminate the large amount of fraying that would result from using wool yardage that is not felted.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Fabrics from wool clothing can also be felted, but use some caution when selecting them. The following guidelines will help in choosing fabrics to recycle and use for felted wool creations.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('span', {
    staticClass: "yellow"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "padding"
  }), _vm._v("Always look for a label identifying the fabric as 100% wool.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('span', {
    staticClass: "yellow"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "padding"
  }), _vm._v("Do not use wool gabardine because it has many more warp than weft yarns and will not felt evenly.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('span', {
    staticClass: "yellow"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "padding"
  }), _vm._v("Melton wool, a heavy cloth that is tightly woven and finished with a smooth face concealing the weave, is often used for overcoats. This wool is excellent for use in appliqués and does not require felting.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg8_1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box-note"
  }, [_c('p', {
    staticClass: "note-head"
  }, [_c('b', [_vm._v("NOTE")])]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_vm._v("Wool yardage typically comes in a 58˝ width; it will shrink a few inches when felted. The supply lists for the projects in this book are based on this standard. If you are using felt made from clothing, you’ll need to do a little experimenting to determine the amount of wool needed.")])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _vm._v("THREADS")])]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('b', [_vm._v("Wool Thread")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("There are many different types of wool thread, which can be found in skeins or on spools. Wool thread is traditionally used in crewel embroidery and is often referred to as crewel thread. It ranges from the weight of two-ply lace-weight yarn to a much finer thread on a spool and can be found in embroidery and needlepoint shops and online. Wool thread does not need to be split but is used as is.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('b', [_vm._v("Cotton Floss")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Cotton floss comes in six-stranded skeins and is generally split (called stripping) to allow the stitcher to decide how thick the embroidery should be. In the majority of the designs in this book, floss is used in a single strand and is therefore split.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('b', [_vm._v("Perle Cotton")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Perle cotton is a single-stranded cotton thread that has a bit of a shine and comes in three weights: #5, #8, and #12, with the latter being the thinnest. Perle cotton is found in skeins and wrapped balls and is often used for decorative embellishment, blanket-stitched edges, and twisted cord.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("TOOLS AND SUPPLIES")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "yellow1"
  }, [_vm._v("NEEDLES")]), _vm._v(" Use crewel needles in a variety of different sizes when working with felted wool appliqué. When basting or making embroidery guides, use a straw needle or a milliners #11.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "yellow1"
  }, [_vm._v("TWEEZERS")]), _vm._v(" This is a critical tool for the placement of shapes under the placement guide.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "yellow1"
  }, [_vm._v("ACETATE")]), _vm._v(" For placement guides, use 8-mil acetate, which should be available on the bolt at your local fabric store.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "yellow1"
  }, [_vm._v("TISSUE")]), _vm._v(" Tissue is available at most stores that carry wrapping paper. Select tissue paper used for gift wrapping when marking your embroidery lines. You can also find larger pieces of tissue paper at office supply stores.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "yellow1"
  }, [_vm._v("SCISSORS")]), _vm._v(" Use scissors with short blades and large handles for the best results when cutting small shapes. Pinking shears are also used in one of the projects to create a zigzag edge to an appliquéd flower.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "yellow1"
  }, [_vm._v("GLUE")]), _vm._v(" You can baste with glue instead of stitches to hold very small appliqué pieces in place while doing the appliqué stitch. My favorite glue is Roxanne Glue-Baste-It, which has a great applicator tip.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg9_1.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-375db2f5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/08_chapter1.vue
// module id = 78
// module chunks = 0